// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"85e344cc","190":"707f9e22","803":"a5a8323b"}[chunkId] + ".chunk.css";
};